import { List } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CollectionSelector from '../collectionselector/CollectionSelector'
import SelectionField from '../searchitems/searchfilters/SelectionField'
import { Accordion, AccordionItem } from '@nextui-org/react'

const CraftSearchFilters = ({
    setVars,
    searchCraftId,
    searchAuthor,
    orderBy,
    searchVerified,
    market,
    isLoading,
    displayCollectionSelector,
}) => {
    const { t } = useTranslation('common')
    const [show, setShow] = useState(true)

    const initToggleItems = () => {
        const map = new Map()
        map.set(t('navigation.collections'), true)
        map.set('Market', market !== undefined)
        return map
    }

    const [toggleItem, setToggleItem] = useState(initToggleItems())

    const toggleShow = () => {
        setShow(!show)
    }

    const onSelectAuthor = (e) => {
        setVars(searchCraftId, e, orderBy, searchVerified, market, 0)
    }

    const onCheckVerified = (e) => {
        setVars(searchCraftId, searchAuthor, orderBy, e, market, 0)
    }

    const onSelectMarket = (e) => {
        setVars(
            searchCraftId,
            searchAuthor,
            orderBy,
            searchVerified,
            e.value,
            0,
        )
    }

    const craftMarketDropdownOptions = [
        { value: 'all', label: 'All' },
        { value: 'nfthivecraft', label: 'NFTHive' },
    ]

    const getMarketOption = (market) => {
        const option = Math.max(
            craftMarketDropdownOptions
                .map((item) => item.value)
                .indexOf(market),
            0,
        )

        return craftMarketDropdownOptions[option]
    }

    const defaultMarketOption = getMarketOption(market)

    return (
        <>
            <div>
                <List>
                    {displayCollectionSelector === undefined ||
                    displayCollectionSelector ? (
                        <Accordion>
                            <AccordionItem
                                title={t('navigation.collections')}
                                toggleItem={toggleItem}
                                setToggleItem={setToggleItem}
                                classNames={{
                                    title: 'dark:dark:text-white !text-base !md:text-xs !xl:text-base font-semibold',
                                }}
                            >
                                <CollectionSelector
                                    searchCollection={searchAuthor}
                                    searchVerified={searchVerified}
                                    selectCollection={onSelectAuthor}
                                    onCheckVerified={onCheckVerified}
                                    searchItem={true}
                                    market={market}
                                    searchType={'crafts'}
                                />
                            </AccordionItem>
                        </Accordion>
                    ) : (
                        ''
                    )}
                    <Accordion>
                        <AccordionItem
                            title={t('search.market')}
                            toggleItem={toggleItem}
                            setToggleItem={setToggleItem}
                            classNames={{
                                title: 'dark:dark:text-white !text-base !md:text-xs !xl:text-base font-semibold',
                            }}
                        >
                            <SelectionField
                                options={craftMarketDropdownOptions}
                                onChange={onSelectMarket}
                                value={defaultMarketOption}
                                placeholder={t('search.market')}
                                id="DropdownField15"
                                disabled={isLoading ? 'disabled' : ''}
                            />
                        </AccordionItem>
                    </Accordion>
                </List>
            </div>
            {/*     <div
                className={cn(
                    { 'block md:hidden': show },
                    { 'hidden md:block': !show },
                )}
            >
                <Tooltip title={'Show filter options'}>
                    <FilterListIcon
                        className={cn('mt-4 ml-2 cursor-pointer')}
                        onClick={toggleShow}
                    >
                        <img src={'/filters.svg'} alt={'Show filter options'} />
                    </FilterListIcon>
                </Tooltip>
            </div> */}
        </>
    )
}

export default CraftSearchFilters
